export const paths = {
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  dashboard: '/dashboard',
  documents: '/documents',
  /** Route PATTERN, not a URL — build one with documentViewerPath(). */
  documentViewer: '/documents/:slug/view',
  profile: '/profile',
  settings: '/settings',
} as const;

export type AppPath = (typeof paths)[keyof typeof paths];

/**
 * The viewer URL for one document.
 *
 * Slugs come from the originating system and are only constrained to
 * `[A-Za-z0-9._-]` by the backend's route, so they are encoded rather than
 * interpolated raw — a stray character would otherwise change which route
 * matched.
 */
export function documentViewerPath(slug: string): string {
  return `/documents/${encodeURIComponent(slug)}/view`;
}
